/**
 * Careers页面配置
 */

export default {
  bannerImgUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/careers/newBanner.jpg',
}
